import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useEffect, useState } from "react";
import { Box, IconSearch, TaggedInput } from "@catchoftheday/cg-components";
import { SEARCH_FACET_FILTERED_DISPLAY_AMOUNT, SEARCH_FACET_SEARCHBOX_THRESHOLD, SEARCH_FACET_TYPE_LIST } from "@search-app/helpers/search/search.helpers.facets";
import { SEARCH_URL_PARAM_FACET } from "@search-app/helpers/search/search.helpers.params";
import { facetAppliedCount } from "@search-app/utilities/facets/applied";
import getCols from "@search-app/utilities/search/search.utilities.getCols";
import getSelectedNames from "@search-app/utilities/search/search.utilities.getSelectedNames";
import { FacetList } from "../../SearchFacets.styles";
import { SearchFacetsBody } from "../SearchFacetsBody";
import { SearchFacetsContainer } from "../SearchFacetsContainer";
import { SearchFacetsHeader } from "../SearchFacetsHeader";
import { SearchFacetsListItem } from "../SearchFacetsListItem/";
import { NoResults } from "../SearchFacetsNoResults";
import { ShowMore } from "../SearchFacetsShowMore/SearchFacetsShowMore";
import { DividerLabel } from "./DividerLabel";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var getUnselectedFilteredValues = function getUnselectedFilteredValues(searchBarTerm, unselectedValues) {
  if (searchBarTerm === "") {
    return unselectedValues;
  }

  return unselectedValues.filter(function (value) {
    var valueNameLower = value.name.toLowerCase();
    var searchBarTermLower = searchBarTerm.toLowerCase();
    return valueNameLower.startsWith(searchBarTermLower);
  });
};
export var SearchFacetsList = function SearchFacetsList(_ref) {
  var facet = _ref.facet,
      isClearAll = _ref.isClearAll,
      isExpanded = _ref.isExpanded,
      _ref$hardCodedCols = _ref.hardCodedCols,
      hardCodedCols = _ref$hardCodedCols === void 0 ? 0 : _ref$hardCodedCols,
      onClear = _ref.onClear,
      onChange = _ref.onChange,
      onExpandChange = _ref.onExpandChange,
      noncollapsible = _ref.noncollapsible,
      scrollable = _ref.scrollable,
      searchTimeout = _ref.searchTimeout,
      isLoading = _ref.isLoading,
      isBrandFacet = _ref.isBrandFacet;
  var id = facet.id,
      facetName = facet.name,
      _facet$values = facet.values,
      values = _facet$values === void 0 ? [] : _facet$values,
      singleSelectionOnly = facet.singleSelectionOnly;
  var facetId = "".concat(SEARCH_URL_PARAM_FACET, "[").concat(id, "]");
  var inputRef = /*#__PURE__*/React.createRef();

  var _useState = useState(-1),
      filteredListFocusIndex = _useState[0],
      setFilteredListFocusIndex = _useState[1];

  var _useState2 = useState(""),
      searchBarTerm = _useState2[0],
      setSearchBarTerm = _useState2[1];

  var _useState3 = useState(SEARCH_FACET_FILTERED_DISPLAY_AMOUNT),
      filteredDisplayAmount = _useState3[0],
      setFilteredDisplayAmount = _useState3[1];

  var _useState4 = useState(values.filter(function (value) {
    return value.selected;
  }).map(function (value) {
    return _objectSpread({}, value);
  })),
      selectedValues = _useState4[0],
      setSelectedValues = _useState4[1];

  var actualDisplayLength = 0;
  useEffect(function () {
    var updatedSelectedValues;

    if (isClearAll) {
      updatedSelectedValues = [];
      setFilteredListFocusIndex(-1);
      setSearchBarTerm("");
      setFilteredDisplayAmount(SEARCH_FACET_FILTERED_DISPLAY_AMOUNT);
    } else {
      updatedSelectedValues = _toConsumableArray(values.filter(function (value) {
        return value.selected;
      }));
    }

    setSelectedValues(updatedSelectedValues);
  }, [values, isClearAll]);
  var selectedNames = getSelectedNames(selectedValues);
  var unselectedFilteredValues = [];
  var onClearHandler = useCallback(function () {
    setSelectedValues([]);
    setFilteredDisplayAmount(SEARCH_FACET_FILTERED_DISPLAY_AMOUNT);

    if (onClear) {
      onClear({
        facet: id
      });
    }
  }, [onClear, id]);
  var toggleValues = useCallback(function (tag, select) {
    onChange({
      facet: id,
      value: tag.id,
      type: SEARCH_FACET_TYPE_LIST
    });

    if (select) {
      setSearchBarTerm("");
      setFilteredListFocusIndex(-1);
    }
  }, [onChange, id]);
  var onTagInputChange = useCallback(function (event) {
    setSearchBarTerm(event.target.value);
    setFilteredListFocusIndex(-1);
  }, []); // Upon user hitting 'Enter', clear input search and update values

  var onTagInputKeyDown = function onTagInputKeyDown(event) {
    if (event.keyCode === 13 || event.key === "Enter") {
      event.preventDefault();

      if (unselectedFilteredValues.length === 0 || filteredListFocusIndex === -1) {
        return;
      }

      toggleValues(unselectedFilteredValues[filteredListFocusIndex], true);
      return;
    } // Upon user hitting 'Escape', clear input search


    if (event.keyCode === 27 || event.key === "Escape") {
      event.preventDefault();
      setSearchBarTerm("");
      setFilteredListFocusIndex(-1);
      return;
    } // Handle when user hits up or down arrow to select facet value


    if (event.keyCode === 40 || event.key === "ArrowDown") {
      event.preventDefault();

      if (filteredListFocusIndex !== actualDisplayLength - 1) {
        setFilteredListFocusIndex(filteredListFocusIndex + 1);
      }

      return;
    }

    if (event.keyCode === 38 || event.key === "ArrowUp") {
      event.preventDefault();

      if (filteredListFocusIndex !== 0) {
        setFilteredListFocusIndex(filteredListFocusIndex - 1);
      }

      return;
    }

    if (event.keyCode === 46 || event.keyCode === 8 || event.key === "Delete") {
      if (searchBarTerm.length === 0 && selectedValues.length > 0) {
        toggleValues(selectedValues[selectedValues.length - 1], 0);
      }
    }
  };

  var getFilteredResult = function getFilteredResult(displayedValues, hasSearchBar) {
    return displayedValues.reduce(function (grouped, value, index) {
      var count = value.count,
          display = value.display,
          id = value.id,
          name = value.name,
          selected = value.selected;
      var facetItemId = "".concat(facetId, "-").concat(id, "-").concat(index);
      var focused = hasSearchBar && filteredListFocusIndex === index;
      var cols = getCols(hardCodedCols, displayedValues);

      var node = ___EmotionJSX(SearchFacetsListItem, {
        checked: selected,
        count: count,
        display: display,
        id: facetItemId,
        key: facetItemId,
        label: name,
        onChange: toggleValues,
        value: value,
        focused: focused,
        columns: cols,
        padding: "0 16px",
        isRadio: singleSelectionOnly,
        name: singleSelectionOnly ? facetName : name
      });

      if (hasSearchBar && cols === 1 && !isBrandFacet) {
        var firstLetter = name.charAt(0).toUpperCase();
        var isSpecialChar = !firstLetter.match(/[A-Z]/);
        var dividerLabel = isSpecialChar ? "#" : firstLetter;

        if (!grouped[dividerLabel]) {
          grouped[dividerLabel] = {
            dividerLabel: dividerLabel,
            children: [node]
          };
        } else {
          grouped[dividerLabel].children.push(node);
        }
      } else {
        if (!grouped[0]) {
          grouped[0] = {
            children: [node]
          };
        } else {
          grouped[0].children.push(node);
        }
      }

      return grouped;
    }, {});
  };

  var hasSearchBar = false;
  var displayedValues = [];
  var hasShowMore = isBrandFacet && values.length > SEARCH_FACET_FILTERED_DISPLAY_AMOUNT && searchBarTerm === "";

  if (scrollable || values.length <= SEARCH_FACET_SEARCHBOX_THRESHOLD) {
    displayedValues = values;
  } else {
    hasSearchBar = true;
    unselectedFilteredValues = getUnselectedFilteredValues(searchBarTerm, values);
    displayedValues = unselectedFilteredValues;
  }

  if (!scrollable && displayedValues.length > filteredDisplayAmount) {
    actualDisplayLength = filteredDisplayAmount;
  } else {
    actualDisplayLength = displayedValues.length;
  }

  var filteredResults = getFilteredResult(displayedValues, hasSearchBar);
  var totalSelected = facetAppliedCount(facet);

  var showMoreItems = function showMoreItems(showLess) {
    setFilteredDisplayAmount(showLess ? SEARCH_FACET_FILTERED_DISPLAY_AMOUNT : 100);
  };

  return ___EmotionJSX(SearchFacetsContainer, {
    id: facetId
  }, ___EmotionJSX(SearchFacetsHeader, {
    id: facetId,
    isExpanded: isExpanded,
    title: facetName,
    searchTimeout: searchTimeout,
    selectedLabel: selectedNames,
    onClear: onClearHandler,
    onExpandChange: onExpandChange,
    noncollapsible: noncollapsible,
    hasSearchBar: hasSearchBar,
    totalSelected: totalSelected
  }), ___EmotionJSX(SearchFacetsBody, {
    isExpanded: isExpanded
  }, hasSearchBar && ___EmotionJSX(TaggedInput, {
    ref: inputRef,
    prefixIcon: IconSearch,
    onChange: onTagInputChange,
    onKeyDown: onTagInputKeyDown,
    onRemoveTag: function onRemoveTag(id) {
      return toggleValues({
        id: id
      }, false);
    },
    placeholder: "Search ".concat(facetName),
    value: searchBarTerm,
    containerProps: {
      mb: "15px"
    },
    fontSize: {
      xs: "base",
      md: "sm"
    },
    labelText: "Search ".concat(facetName)
  }), ___EmotionJSX(Box, {
    position: "relative"
  }, displayedValues.length <= 0 ? ___EmotionJSX(NoResults, null) : Object.keys(filteredResults).map(function (key, index) {
    var _filteredResults$key = filteredResults[key],
        dividerLabel = _filteredResults$key.dividerLabel,
        children = _filteredResults$key.children;
    return ___EmotionJSX(React.Fragment, {
      key: "item-".concat(index)
    }, dividerLabel && ___EmotionJSX(DividerLabel, {
      style: {
        zIndex: isLoading ? 0 : 1
      }
    }, dividerLabel), ___EmotionJSX(FacetList, {
      scrollable: false,
      hasSearchBar: hasSearchBar
    }, children.slice(0, isBrandFacet ? filteredDisplayAmount : children.length).map(function (child) {
      return child;
    })));
  }), hasShowMore && ___EmotionJSX(ShowMore, {
    onClickHandler: showMoreItems,
    showLess: filteredDisplayAmount > SEARCH_FACET_FILTERED_DISPLAY_AMOUNT
  }))));
};